import * as React from 'react'
import { FormValue, FileTextValue } from '../../reducers/form-values'
import { inputValueChangeFn } from './form-type-selector'
import { nl2br, targetBlankifyLinks } from '../utils'
import { errorMsg } from './build-error-msg'
import { strings } from '../localization'

export function buildThumbs (data, value: FileTextValue, inputValueChange: inputValueChangeFn) {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => inputValueChange(data.qid, 'textInput', e.target.value)
  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>, value: string) => {
    if (e.key === ' ') {
      e.preventDefault()
      inputValueChange(data.qid, data.field_type, value)
    }
  }

  const labelHtml = {
    __html: nl2br(targetBlankifyLinks(data.label))
  }
  const labelId = `radio-group-${data.qid}`

  return (
    <div className={data.className ? data.className : 'col-xs-12'} key={data.qid}>
      <div
        className={'input-line input-rating'}
        role='radiogroup'
        aria-required={data.required}
        aria-labelledby={labelId}
      >
      {data.label && <label>
        <span id={labelId} dangerouslySetInnerHTML={labelHtml}></span>
         <span className='fieldRequired'>{data.required && '*'}</span>
      </label>}
      <div className='npsThumbs'>
        <div className='npsThumbsContent'>
          <input
            type='radio'
            id={`thumbs-${data.qid}-0`}
            name={`thumbs-${data.qid}`}
            value='thumbUp'
            onChange={onChange}
            checked={value.value === 'thumbUp'}
             />
              <label
                role='radio'
                aria-label={strings.a11yRadioThumbsUp}
                aria-checked={value.value === 'thumbUp'}
                tabIndex={0}
                className='thumbUp'
                htmlFor={`thumbs-${data.qid}-0`}
                onKeyDown={(e) => handleKeyDown(e, 'thumbUp')}
                ></label>
          <input
            type='radio'
            id={`thumbs-${data.qid}-1`}
            name={`thumbs-${data.qid}`}
            value='thumbDown'
            onChange={onChange}
            checked={value.value === 'thumbDown'} />
              <label
                role='radio'
                aria-label={strings.a11yRadioThumbsDown}
                aria-checked={value.value === 'thumbDown'}
                tabIndex={0}
                className='thumbDown'
                htmlFor={`thumbs-${data.qid}-1`}
                onKeyDown={(e) => handleKeyDown(e, 'thumbUp')}
                ></label>
        </div>
      </div>
      {data.errorMessage &&
        errorMsg(data.qid, data.errorMessage)}
    </div></div>
  )
}
